/**
 * 咒语解析选择
 */
import React from 'react'
import { Tooltip, Radio } from 'antd'
import { QuestionCircleOutlined } from '@ant-design/icons'
import { spellAnalysisImgTypeAtom } from './atom'
import { useAtom } from 'jotai'

interface IProps {
  radioKey?: string
  scrollId?: string
  // 参考图
  formLabel?: string
  formNotice?: string
  hasRadio?: boolean
}
const FormLabelImgToTag: React.FC<IProps> = ({
  radioKey,
  scrollId,
  formLabel,
  formNotice,
  hasRadio,
}) => {
  const [selected, setSelected] = useAtom(spellAnalysisImgTypeAtom)

  return (
    <div className="w-full flex justify-between items-center mb-1 text-neutral-500">
      <span id={scrollId}>
        {formLabel}{' '}
        {!!formNotice && (
          <Tooltip placement="topLeft" arrowPointAtCenter title={formNotice}>
            <QuestionCircleOutlined />
          </Tooltip>
        )}
      </span>
      {hasRadio && (
        <span>
          <Tooltip
            placement="topLeft"
            arrowPointAtCenter
            title="此功能开启后，作画过程的画面描述词将会自动帮你解析，你无需输入描述词即可生成（如有输入将会以自动生成的为准）"
          >
            <QuestionCircleOutlined />
          </Tooltip>
          <Radio
            className="flex flex-row-reverse"
            checked={selected === radioKey}
            onClick={() => {
              let _name
              if (selected !== radioKey) {
                _name = radioKey
              }
              setSelected(_name as any)
            }}
          >
            <span className="text-neutral-400">咒语解析</span>
          </Radio>
        </span>
      )}
    </div>
  )
}
export default FormLabelImgToTag
